import { styles } from "./styles";
import React from "react";

import { Layout, Flex } from "antd";
import { Route, Routes } from "react-router";
import { Screens } from "@constants/screens";
import { Content } from "antd/es/layout/layout";
import LoginScreen from "@screens/LoginScreen/LoginScreen";
import { Redirect } from "@shared/router/Redirect/Redirect";

const RouterGuest = (): JSX.Element => (
  <Flex gap="middle" wrap="wrap">
    <Layout className={styles.layout}>
      <Content className={styles.content}>
        <Routes>
          <Route
            path={"*"}
            element={<Redirect from={"*"} to={Screens.Login.path()} />}
          />
          <Route path={Screens.Login.path()} element={<LoginScreen />} />
        </Routes>
      </Content>
    </Layout>
  </Flex>
);

export default RouterGuest;
